import {Loader} from '@googlemaps/js-api-loader';

// CF provided API key
const googleMapsAPIkey = 'AIzaSyC5LkPZOtli1EnDTOZSdnEVSbexrHYQRLw';



export default () => {
    lazyLoadGMaps();

    let activeMarker = null;

    function initLoader() {
        const loader = window.loader || new Loader({
            apiKey: googleMapsAPIkey,
            version: 'weekly',
            libraries: ['places', 'marker'],
        });

        loader.load().then(() => {
            if (window.shPropertyAddress) {
                const addressData = window.shPropertyAddress;
                const geocoder = new window.google.maps.Geocoder();

                if (geocoder) {
                    console.log('geocoding addresses');
                    getAddressGeocode(addressData, geocoder, initialize)
                }
            }
        });
    }

    function getAddressGeocode(addressData, geocoder, callback) {
        let currAddress, processed = 0;
        addressData.forEach((address, index) => {
            currAddress = address.address;
            geocoder.geocode(
                {'address':currAddress},
                function(results, status) {
                    if (status == window.google.maps.GeocoderStatus.OK) {
                        processed++
                        let geocoded = results[0].geometry.location;
                        addressData[index].location = { lat: geocoded.lat(), lng: geocoded.lng() }

                        if (processed == addressData.length) {
                            callback(addressData);
                        }
                    }
                }
            );
        });
    }

    function lazyLoadGMaps() {
        initLoader();
    }

    function initialize(formattedAddressData) {
        console.log('initilzing map');
        window.shPropertyMarkers = [];

        if (window.google !== undefined && window.google.maps) {

            let bounds = new window.google.maps.LatLngBounds();
            const mapOptions = {
                mapId: '36835201284e96f3',
                mapTypeId: 'roadmap',
            };

            window.shPropertyAddressMap = new window.google.maps.Map(document.querySelector('.js-al-properties-map'), mapOptions);
            window.shPropertyAddressMap.setTilt(45);

            addPropertyMarkers(formattedAddressData, window.shPropertyAddressMap, bounds);
            window.shPropertyAddressMap.fitBounds(bounds);

            document.querySelector('.js-al-properties-content').classList.remove('al-properties__content-is-loading');
            const spinnerElement = document.querySelector('.js-isp-spinner');
            if (spinnerElement) {
                spinnerElement.remove();
            }
        }

        return true;
    }

    function createCustomIcon(isHoveredOrClicked = false) {
        const div = document.createElement('div');
        div.classList.add('custom-marker');
        if (isHoveredOrClicked) {
            div.classList.add('active');
            div.classList.remove('inactive');
        } else {
            div.classList.add('inactive'); 
            div.classList.remove('active');
        }
        
        div.style.width = '35px'; 
        div.style.height = '35px';
        return div;
    }

    function showPropertyDetails(property) {
        const detailsSection = document.querySelector('.map-listing-card');
        if (!detailsSection) {
            return;
        }

        const listingTitle = detailsSection.querySelector('.listing-title');
        const listingAddress = detailsSection.querySelector('.listing-address');
        const listingScoreValue = detailsSection.querySelector('.listing-card__score-value');
        const summarySpan = detailsSection.querySelector('.listing-summary .summary');
        const summaryMoreBtn = detailsSection.querySelector('.listing-summary .summary-more');
        const summaryLessBtn = detailsSection.querySelector('.listing-summary .summary-less');
        const categoryWrapper = detailsSection.querySelector('.listing-categories .category-wrapper');
        const closeButton = detailsSection.querySelector('.close-details-button');

        if (!listingTitle || !listingAddress || !listingScoreValue || !summarySpan) {
            return;
        }

        listingTitle.textContent = property.name || 'N/A';
        listingAddress.textContent = property.address || 'N/A';
        listingScoreValue.textContent = property.score ? property.score : 'N/A';

        const fullSummaryText = property.summary?.full_summary || property.description || '';
        const isMobile = window.innerWidth <= 768;

        summarySpan.textContent = fullSummaryText;
        summarySpan.dataset.fullText = fullSummaryText;

        if (!isMobile) {
            if (summaryMoreBtn) summaryMoreBtn.style.display = 'none';
            if (summaryLessBtn) summaryLessBtn.style.display = 'none';
        } else {
            if (window.listingsSummaryHandler) {
                window.listingsSummaryHandler.processNewContent(detailsSection);
            }
        }

        if (categoryWrapper) {
            categoryWrapper.innerHTML = '';
            if (property.categories && Array.isArray(property.categories)) {
                property.categories.forEach(category => {
                    const categorySpan = document.createElement('span');
                    categorySpan.classList.add('cat-pills');
                    categorySpan.textContent = category.name || category;
                    categoryWrapper.appendChild(categorySpan);
                });
            }
        }

        detailsSection.style.display = 'block';

        if (closeButton) {
            closeButton.onclick = function() {
                detailsSection.style.display = 'none';

                if (activeMarker) {
                    activeMarker.customIconElement.classList.remove('active');
                    activeMarker.customIconElement.classList.add('inactive');
                    activeMarker = null;
                }

                // GTM for closing details
                const defaultData = {
                    'event': 'on_page_link_click',
                    'elementPlacement': 'in-content',
                    'elementClicked': 'map-details-close',
                    'position': 'single',
                    'pageUrl': window.location.href,
                    'direction': 'close',
                };
                window.dataLayer.push(defaultData);
                console.log(defaultData);
            };
        }
    }

    // Add Markers to Map
    function addPropertyMarkers(properties, map, bounds) {
        if (window.google !== undefined && window.google.maps) {
            let mapMarkers = [];
            let fullPropertyData = properties;

            properties.forEach(property => {
                mapMarkers.push([property.name, property.location.lat, property.location.lng]);
            })

            let infoWindow = new window.google.maps.InfoWindow({
                headerDisabled: true,
            });

            for (let i = 0; i < mapMarkers.length; i++) {
                let position = new window.google.maps.LatLng(mapMarkers[i][1], mapMarkers[i][2]);
                bounds.extend(position);
                const markerContent = createCustomIcon(false);
                let marker = new window.google.maps.marker.AdvancedMarkerElement({
                    position: position,
                    map,
                    title: mapMarkers[i][0],
                    content: markerContent,
                });

                marker.customIconElement = markerContent;

                let propertyAddress = fullPropertyData[i].address == null ? '' : fullPropertyData[i].address;
                let infoWindowHtml =
                    `<div class='map-info-content'>
                        <h5 class='map-info-content__title'>
                            ${fullPropertyData[i].name}
                        </h5>
                        <p class='map-info-content__address'>
                            ${propertyAddress}
                        </p>
                    </div>`;

                marker.customIconElement.addEventListener('mouseover', function () {
                    if (activeMarker !== marker) {
                        marker.customIconElement.classList.remove('inactive'); 
                        marker.customIconElement.classList.add('active');
                    }
                    infoWindow.setContent(infoWindowHtml);
                    infoWindow.open(map, marker);


                    const defaultData = {
                        'event': 'on_page_link_click',
                        'elementPlacement': 'in-content',
                        'elementClicked': 'property-map-marker-hover',
                        'elementName': 'map-marker',
                        'pageUrl': window.location.href,
                        'position': i + 1,
                        'linkText': marker.title,
                    };
                    window.dataLayer.push(defaultData);
                    console.log(defaultData);
                });


                marker.customIconElement.addEventListener('mouseout', function () {
                    infoWindow.close();

                    if (activeMarker !== marker) {
                        marker.customIconElement.classList.remove('active');
                        marker.customIconElement.classList.add('inactive');
                    }
                });

                marker.customIconElement.addEventListener('click', function () {
                    map.panTo(marker.position); // Close any open info window on click
                    if (activeMarker && activeMarker !== marker) {
                        activeMarker.customIconElement.classList.remove('active');
                        activeMarker.customIconElement.classList.add('inactive');
                    }
                    activeMarker = marker;
                    marker.customIconElement.classList.remove('inactive');
                    marker.customIconElement.classList.add('active');
                    showPropertyDetails(fullPropertyData[i]);

                    const defaultData = {
                        'event': 'on_page_link_click',
                        'elementPlacement': 'in-content',
                        'elementClicked': 'property-map-marker-click',
                        'elementName': 'map-marker',
                        'pageUrl': window.location.href,
                        'position': i + 1,
                        'linkText': marker.title,
                    };
                    window.dataLayer.push(defaultData);
                    console.log(defaultData);
                });

                window.shPropertyMarkers.push(marker);
            }
        }
    }
}
